import { store } from 'react-easy-state'

const _store = store({
  firstName: '',
  lastName: '',
  birthday: '',
  idCardNumber: '',
  laser: '',
  email: '',
  mobileNumber: '',

  setAll(firstName, lastName, birthday, idCardNumber, laser, email, mobileNumber) {
    _store.firstName = firstName
    _store.lastName = lastName
    _store.birthday = birthday
    _store.idCardNumber = idCardNumber
    _store.laser = laser
    _store.email = email
    _store.mobileNumber = mobileNumber
  },

  setMyPolicy(firstName, lastName, idCardNumber, mobileNumber) {
    _store.firstName = firstName
    _store.lastName = lastName
    _store.idCardNumber = idCardNumber
    _store.mobileNumber = mobileNumber
  }
})

export default _store
